import { render, staticRenderFns } from "./OrticPageLength.vue?vue&type=template&id=eb7bbd4a&"
import script from "./OrticPageLength.vue?vue&type=script&lang=js&"
export * from "./OrticPageLength.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports